export default __webpack_public_path__ + "static/media/mat-man-loader.916f5baa.png";